'use client';

import { useTranslation } from 'react-i18next';

type TabSwitcherProps = {
  activeTab: 'subscription' | 'points';
  onTabChange: (tab: 'subscription' | 'points') => void;
};

export const TabSwitcher: React.FC<TabSwitcherProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex bg-neutral-600 rounded-[50px] relative text-sm text-white h-12 z-1">
      {/* Sliding Background */}
      <div
        className={`absolute top-[0px] bottom-[0px] left-[0px] w-[50%] bg-primary-300 rounded-[25px] transition-transform duration-300 ease-in-out ${
          activeTab === 'points' ? 'translate-x-full' : 'translate-x-0'
        }`}
      />

      <button
        onClick={() => onTabChange('subscription')}
        className="flex-1 py-2.5 px-5 rounded-[25px] font-bold transition-colors relative z-10"
      >
        {t('subscription:second_tab_new', 'Unlimited Reading')}
      </button>
      <button
        onClick={() => onTabChange('points')}
        className="flex-1 py-2.5 px-5 rounded-[25px] font-bold transition-colors relative z-10"
      >
        {t('shop:buy_chapters', 'Buy Chapters')}
      </button>
    </div>
  );
};
